import { useMemo } from 'react';

import { mapValues } from 'lodash-es';

import type { TranslationName } from './useCopyI18nKeys';
import { useCopyI18nKeys } from './useCopyI18nKeys';
import { useCopyOverrides } from './useCopyOverrides';

type Result = ModelHookResult<Record<TranslationName, string>>;

export function usePageCopy(): Result {
	const {
		data: { keys },
		actions: { translateKey },
	} = useCopyI18nKeys();
	const {
		data: { overrides },
	} = useCopyOverrides();

	const labels = useMemo(() => {
		return mapValues(
			keys,
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			(i18nKey, name) => overrides[name as TranslationName] ?? translateKey(name as TranslationName, i18nKey),
		);
	}, [keys, translateKey, overrides]);

	return {
		data: labels,
	};
}
